// src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import App from './App.jsx'
import { AuthProvider } from './Context/AuthContext.jsx'
import { queryClient } from './lib/queryClient.js'
import './index.css'

// After a deploy, a tab opened earlier still references the previous build's chunk files, which no longer
// exist, so opening a page fails to load. Reload once to pick up the new build; the timestamp stops a loop
// if the chunk is genuinely unavailable.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'astra:chunk-reload-at'
  const last = Number(sessionStorage.getItem(key) || 0)
  if (Date.now() - last < 10_000) return
  sessionStorage.setItem(key, String(Date.now()))
  event.preventDefault()
  window.location.reload()
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
      
      {/* React Query DevTools - only visible in development */}
      {import.meta.env.DEV && (
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      )}
    </QueryClientProvider>
  </React.StrictMode>
)
